import React from 'react';
import { Tabs } from 'antd';
import { useT } from 'hooks/Locale/useT';
import Filters from './Filters';
import Access from './Access';
import { connect } from 'react-redux';

const mapStateToProps = (state: any) => {
    return {
        session: state.session,
    };
};

interface UserCustomFiltersInterface {
    session: any;
}

const UsersCustomFilters: React.FC<UserCustomFiltersInterface> = ({ session }) => {
    const t = useT();

    const items = [
        {
            label: t('system.general_users_filters'),
            key: 'user-filters',
            children: <Filters />,
        },
        {
            label: t('system.general_users_filters_access'),
            key: 'user-filters-access',
            children: <Access />,
        },
    ];

    const filteredItems = items.filter((item: any) => {
        if (item.key === 'user-filters-access' && session.active_user_type === 'CUSTOMER_ADMIN') {
            return false;
        }
        return true;
    });

    return <Tabs items={filteredItems} />;
};

export default connect(mapStateToProps)(UsersCustomFilters);
